import { render } from "./ContactoDealer.vue?vue&type=template&id=4e7cb2e9&scoped=true&ts=true"
import script from "./ContactoDealer.vue?vue&type=script&lang=ts"
export * from "./ContactoDealer.vue?vue&type=script&lang=ts"

import "./ContactoDealer.vue?vue&type=style&index=0&id=4e7cb2e9&scoped=true&lang=css"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7cb2e9"]])

export default __exports__